/**
 * Transforms various Date formats (Date object, timestamp, or string)
 * into the "DD.MM.YYYY" format. Returns undefined if the input is invalid.
 */
export const formatDateToDDMMYYYY = (
  dateInput: unknown
): string | undefined => {
  if (!dateInput) return undefined;

  const date = new Date(dateInput as any);

  // Check for Invalid Date
  if (isNaN(date.getTime())) {
    return undefined;
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};
